export default "__VITE_ASSET__BEo8LzJf__"